const removeDuplicateTags = tags => {
  const tagList = Array.from(new Set(tags.map(a => a.label))).map(label => {
    return tags.find(a => a.label === label)
  })

  return tagList
}

export default removeDuplicateTags
